import { useState, type FormEvent } from 'react';
import { api, ApiError } from '../api';
import { useAuth } from '../App';
import { Sigil } from '../ui';

const MESSAGES: Record<string, string> = {
  bad_credentials: 'Rangt notandanafn eða lykilorð.',
  missing_credentials: 'Fylltu út bæði reitina.',
  too_many_attempts: 'Of margar tilraunir. Reyndu aftur eftir stutta stund.',
};

export default function Login() {
  const { setUser } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const { user } = await api.login(username, password);
      setUser(user);
    } catch (err) {
      const code = err instanceof ApiError ? err.code : 'network';
      setError(MESSAGES[code] ?? 'Tenging mistókst. Er vefþjónninn í gangi?');
      setPassword('');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="login" onSubmit={submit}>
        <span className="login-mark">
          <Sigil size={60} />
        </span>

        <h1>Stjórnborð</h1>
        <p className="sub">Spilafélag Vestfjarða</p>

        {error && <div className="alert" role="alert">{error}</div>}

        <div className="fld">
          <label className="lbl" htmlFor="u">Notandanafn</label>
          <input
            id="u"
            type="text"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoFocus
          />
        </div>

        <div className="fld">
          <label className="lbl" htmlFor="p">Lykilorð</label>
          <input
            id="p"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button className="btn wide" type="submit" disabled={busy}>
          {busy ? 'Augnablik…' : 'Skrá inn'}
        </button>
      </form>
    </div>
  );
}
